export {Pioneers as Page};

import {Helmet} from "react-helmet-async";
import {useEffect, useState} from "preact/hooks";
import messages from "../../messages/messages.js";
import API_URL from "../../includes/api.js";
import {ChevronLeftIcon, ChevronRightIcon, XMarkIcon} from "@heroicons/react/24/solid";
import {RingSpinner} from "../../components/Spinner.jsx";

function Pioneers() {

    const [showDialog, setShowDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState({});
    const [loading, setLoading] = useState(true);
    const [members, setMembers] = useState([]);

    useEffect(() => {
        fetch(API_URL + "/member/all?type=pioneer&limit=10000")
            .then(response => response.json()).then(data => {
            if (data.code === 200) {
                setMembers(data.data);
            }
        }).finally(() => {
            setLoading(false);
        });

        const closeDialog = (e) => {
            if (e.target.id === 'member-dialog' && showDialog) {
                setShowDialog(false);
            }
        }
        window.addEventListener('click', closeDialog);
        return () => window.removeEventListener('click', closeDialog);
    }, [])

    // change member in dialog
    const changeMember = (prev) => () => {
        const index = members.findIndex(member => member.channel_id === dialogContent.channel_id);
        const newIndex = (prev ? (index - 1 + members.length) : (index + 1)) % members.length;
        setDialogContent(members[newIndex]);
    };

    return (<>
            <Helmet>
                <title>{messages["SITE.NAME"]} | Network members</title>
                <meta name="description"
                      content={`Discover the ${messages["SITE.NAME"]} member pioneers! Explore profiles of creators, fans, and enthusiasts who make up our vibrant community. Celebrate the passion that drives the ${messages["SITE.NAME"]} movement!`}/>
            </Helmet>

            <div id="member-dialog"
                 className={`${showDialog ? 'block' : 'hidden'} fixed top-0 left-0 right-0 z-50 p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full bg-black/30`}
                 role="dialog"
                 aria-modal="true"
                 aria-labelledby="pioneer-dialog-title"
                 style={{height: "100%"}}>
                <div className="relative w-full max-w-md max-h-full mx-auto top-40">
                    <button className="text-white flex absolute cursor-pointer" onClick={changeMember(true)}
                            aria-label="Previous pioneer" style={{top: '40%', left: "-40px"}}>
                        <ChevronLeftIcon className={"w-5 h-5"} aria-hidden="true"/>
                    </button>
                    <button className="text-white flex absolute cursor-pointer" onClick={changeMember(false)}
                            aria-label="Next pioneer" style={{top: '40%', right: "-40px"}}>
                        <ChevronRightIcon className={"w-5 h-5"} aria-hidden="true"/>
                    </button>
                    <div className="relative bg-neutral-900 rounded-lg shadow-sm border-2 border-white">
                        <button onClick={() => setShowDialog(false)} aria-label="Close pioneer dialog"
                                className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                            <XMarkIcon className="w-5 h-5" aria-hidden="true"/>
                        </button>
                        <div className="p-6 text-center">
                            <div className="flex flex-row gap-5 gap-y-3 flex-wrap">
                                <img alt={dialogContent.channel_name} src={dialogContent.image_data}
                                     onError={(e) => e.target.src = '/img/Portrait_Placeholder.png'}
                                     className="rounded-lg h-full" style={{maxWidth: 100}}/>
                                <div className="flex flex-col justify-center items-start gap-2">
                                    <h2 id="pioneer-dialog-title" className="text-xl font-bold m-0">{dialogContent.channel_name}</h2>
                                    <a href={`https://youtube.com/channel/` + dialogContent.channel_id} target="_blank" rel="noopener noreferrer"
                                       className="inline-block text-sm py-2 px-5 font-medium text-center text-white rounded-lg border border-gray-300 hover:bg-white hover:text-black">Visit
                                        channel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="text-white font-light">

                <div className="flex text-center flex-col items-center">

                    <h1>Network Pioneers</h1>
                    <p className="max-w-4xl">
                        Meet the pioneers of {messages["SITE.NAME"]}! Discover the trailblazers, creators, and
                        visionaries who are shaping our community. Explore their profiles, celebrate their achievements,
                        and be inspired to join the {messages["SITE.NAME"]} movement!</p>

                    {loading ? (
                        <div className="mt-12">
                            <div role="status">
                                <RingSpinner className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-red-400" trackFill="currentColor"/>
                            </div>
                            <h2 className="text-2xl font-bold">Loading...</h2>
                        </div>
                    ) : (
                        <div className="my-8">
                            <div className="flex flex-wrap gap-5 justify-center">
                                {members.map((member) => <button
                                    key={member.channel_id}
                                    type="button"
                                    onClick={() => {
                                        setDialogContent(member);
                                        setShowDialog(true);
                                    }}
                                    aria-label={`Open pioneer ${member.channel_name}`}
                                    className="rounded-lg cursor-pointer member"
                                ><img width={88} height={88} alt={member.channel_name} src={member.image_data}
                                       onError={(e) => e.target.src = '/img/Portrait_Placeholder.png'}
                                       className="rounded-lg"/></button>)}
                            </div>
                        </div>
                    )}

                    <a href="/get-in-touch?topic=apply-pioneer"
                       className="inline-block py-2 px-6 font-medium text-center text-white rounded-full border border-gray-300 hover:bg-white hover:text-black cursor-pointer">Apply
                        now</a>

                </div>
            </section>
        </>
    );
}
